import type DotLottieAnimation from './types';

const DotLottieAnimations: Record<string, DotLottieAnimation> = {
    ExpensifyLounge: {
        file: require('@assets/animations/ExpensifyLounge.lottie'),
        w: 1920,
        h: 1080,
    },
    FastMoney: {
        file: require('@assets/animations/FastMoney.lottie'),
        w: 375,
        h: 240,
    },
    Fireworks: {
        file: require('@assets/animations/Fireworks.lottie'),
        w: 360,
        h: 360,
    },
    Hands: {
        file: require('@assets/animations/Hands.lottie'),
        w: 375,
        h: 375,
    },
    PreferencesDJ: {
        file: require('@assets/animations/PreferencesDJ.lottie'),
        w: 375,
        h: 240,
    },
    ReviewingBankInfo: {
        file: require('@assets/animations/ReviewingBankInfo.lottie'),
        w: 280,
        h: 280,
    },
    WorkspacePlanet: {
        file: require('@assets/animations/WorkspacePlanet.lottie'),
        w: 375,
        h: 240,
    },
    SaveTheWorld: {
        file: require('@assets/animations/SaveTheWorld.lottie'),
        w: 375,
        h: 240,
    },
    Safe: {
        file: require('@assets/animations/Safe.lottie'),
        w: 625,
        h: 400,
    },
    Magician: {
        file: require('@assets/animations/Magician.lottie'),
        w: 853,
        h: 480,
    },
    Coin: {
        file: require('@assets/animations/Coin.lottie'),
        w: 375,
        h: 240,
    },
};

export default DotLottieAnimations;
